var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFED9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 33.7493V31.416",
    stroke: "#DB6E00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9794 36.4855C19.2418 38.4341 20.8558 39.9608 22.8199 40.0511C24.4726 40.127 26.1515 40.1667 28.0003 40.1667C29.8491 40.1667 31.528 40.127 33.1807 40.0511C35.1448 39.9608 36.7589 38.4341 37.0212 36.4855C37.1924 35.2138 37.3337 33.9106 37.3337 32.5833C37.3337 31.2561 37.1924 29.9529 37.0212 28.6811C36.7589 26.7325 35.1448 25.2059 33.1807 25.1156C31.528 25.0396 29.8491 25 28.0003 25C26.1515 25 24.4726 25.0396 22.8199 25.1156C20.8558 25.2059 19.2418 26.7325 18.9794 28.6811C18.8082 29.9529 18.667 31.2561 18.667 32.5833C18.667 33.9106 18.8082 35.2138 18.9794 36.4855Z",
    stroke: "#DB6E00",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 24.9997V22.083C22.75 19.1835 25.1005 16.833 28 16.833C30.8995 16.833 33.25 19.1835 33.25 22.083V24.9997",
    stroke: "#DB6E00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.30d78120e6786a79318c74818e104b54.svg";
export { ForwardRef as ReactComponent };